import { useAppSelector } from "../../hooks/reduxhooks"
import Spinner from "../layout/Spinner"
import UserItem from "./UserItem"
function UserResults(): JSX.Element {
  const { users, loading } = useAppSelector((state) => state.githubState)
  if (!loading) {
    return (
      <div className="grid grid-cols-1 gap-8 xl:grid-col-4 lg:grid-cols-3 md:grid-cols-2">
        {users.map((user) => (
          <UserItem key={user.id} user={user} />
        ))}
      </div>
    )
  } else {
    return <Spinner />
  }
}

export default UserResults
